class CollectionProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(
      ".collection-product-slider__collection-selector",
    );
    this.sliders = this.querySelectorAll(
      ".collection-product-slider__product-slider",
    );
    this.wrappers = this.querySelectorAll(
      ".collection-product-slider__slider-wrapper",
    );

    this.handleClick = this.handleClick.bind(this);
    this.handleArrowClick = this.handleArrowClick.bind(this);

    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleClick);
    });

    this.wrappers.forEach((wrapper) => {
      const arrows = wrapper.querySelectorAll(
        ".collection-product-slider__arrow",
      );
      arrows.forEach((arrow) => {
        arrow.addEventListener("click", this.handleArrowClick);
      });
    });

    this.sliders.forEach((slider) => {
      const wrapper = slider.closest(
        ".collection-product-slider__slider-wrapper",
      );
      if (wrapper) {
        const arrows = wrapper.querySelectorAll(
          ".collection-product-slider__arrow",
        );
        if (slider.scrollWidth <= slider.clientWidth + 1) {
          arrows.forEach((arrow) => {
            arrow.classList.add("opacity-0", "pointer-events-none");
          });
        } else {
          slider.addEventListener("scroll", this.handleScroll);
        }
      }
    });
  }

  disconnectedCallback() {
    this.wrappers.forEach((wrapper) => {
      const arrows = wrapper.querySelectorAll(
        ".collection-product-slider__arrow",
      );
      arrows.forEach((arrow) => {
        arrow.removeEventListener("click", this.handleArrowClick);
      });
    });
    this.sliders.forEach((slider) => {
      slider.removeEventListener("scroll", this.handleScroll);
    });
    this.buttons.forEach((button) => {
      button.removeEventListener("click", this.handleClick);
    });
  }

  handleScroll(event) {
    const slider = event.currentTarget;
    const wrapper = slider.closest(
      ".collection-product-slider__slider-wrapper",
    );
    if (!wrapper) return;

    const arrows = wrapper.querySelectorAll(
      ".collection-product-slider__arrow",
    );
    const isAtStart = slider.scrollLeft === 0;
    const isAtEnd =
      slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;

    arrows.forEach((arrow) => {
      const isLeft = arrow.classList.contains(
        "collection-product-slider__arrow--left",
      );
      if (isLeft) {
        if (isAtStart) {
          arrow.classList.add("opacity-0", "pointer-events-none");
        } else {
          arrow.classList.remove("opacity-0", "pointer-events-none");
        }
      } else {
        if (isAtEnd) {
          arrow.classList.add("opacity-0", "pointer-events-none");
        } else {
          arrow.classList.remove("opacity-0", "pointer-events-none");
        }
      }
    });
  }

  handleClick(event) {
    const target = event.target;
    const collection = target.dataset.collection;

    let activeSlider = null;

    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      const wrapper = this.wrappers[i];
      if (button.dataset.collection === collection) {
        button.dataset.visibility = "show";
        button.scrollIntoView({
          block: "nearest",
          container: "nearest",
          behavior: "smooth",
          inline: "center",
        });
        wrapper.dataset.visibility = "show";
        activeSlider = this.sliders[i];
      } else {
        button.dataset.visibility = "hidden";
        wrapper.dataset.visibility = "hidden";
      }
    }

    if (activeSlider) {
      activeSlider.dispatchEvent(new Event("scroll"));
    }
  }

  handleArrowClick(event) {
    const parent = event.currentTarget.parentElement;
    const slider = parent.querySelector(
      ".collection-product-slider__product-slider",
    );
    const isLeft = event.currentTarget.classList.contains(
      "collection-product-slider__arrow--left",
    );
    const toSlideWidth = slider.clientWidth - 200;
    slider.scrollBy({
      left: isLeft ? -toSlideWidth : toSlideWidth,
      behavior: "smooth",
    });
  }
}

customElements.define("collection-product-slider", CollectionProductSlider);
